export enum UserPermissionValue {
  READ = 'read',
  WRITE = 'write',
  NONE = 'none',
}
